// @flow
import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/progress.css'
import { withRouter } from 'react-router-dom'
import config from 'config'

function QuestProgress({ location }: { location: any }) {
  let val = 1

  if (
    location.pathname.startsWith(config.routes.articleMatch) ||
    location.pathname.startsWith(config.routes.articleLastMatch)
  ) {
    val = 3
  } else if (location.pathname.startsWith(config.routes.teamSelection)) {
    val = 2
  }

  return (
    <div className='ui top attached green progress' id='progressbar'>
      <div className='bar' style={{ width: `${(val / 3) * 100}%` }} />
    </div>
  )
}

export const ProgressSteps = withRouter(QuestProgress)
